module.exports = __webpack_public_path__ + "static/media/Revfin-SeriesA-funding.592e5683.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Revfin-SeriesA-funding.webp
// module id = 306
// module chunks = 0